module.exports = __webpack_public_path__ + "static/media/12.162d1498.png";